<template>
  <div class="clearfix">
       
      <a-upload
        :listType="listType"
        :showUploadList="showUploadList"
        action=""
        :fileList="fileList"
        :customRequest="uploadImg"
        @change="imageChange"
        :class="fleft?'fleft':signalCla?'signalCla':''"
        :multiple="multiple"
        @preview="handlePreview"
        :disabled="disabled"
        :beforeUpload="beforeUpload"
      >
      <div v-if="!showUploadList" class="bf">
         <img v-if="imageUrl" :src="imageUrl"  class="upImg" />

        <div v-else :class="signalCla?'upload-Add':''">
          <a-icon :type="loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">Upload</div>
        </div>
      </div>
    <div v-else-if="listType==='picture-card'&&fileList&&fileList.length < imageCount" style="padding-top: 20px;">
        <a-icon type="plus" />
        <div class="ant-upload-text">Upload</div>
    </div>
    <div v-else-if="listType==='text'">
      <a-button>
        <a-icon type="upload" /> Upload
      </a-button>
    </div>
  </a-upload>
  <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img style="width: 100%;padding: 15px;" :src="previewImage" />
    </a-modal>

  </div>
</template>

<script>
import { api, exzends, rules } from "@/common";
export default {
  name: "uploadImage",
  props:{
    isAvatar: {
      type: Number,
      default: 0
    },
    imageInit:{
      type:String,
      default:null
    },
    showUploadList:{type:[Object,Boolean],default:true},
    listType:{type:String,default:"picture-card"},
    fileListInit:{type:Array,default:[]},
    imageCount:{type:Number,default:1},
    fleft:{type:Boolean,default:false},
    multiple:{type:Boolean,default:false},
    signalCla:{type:Boolean,default:false},
    disabled:{type:Boolean,default:false},
    fileVaildtor:{type:Object,default:null}
  },
  data() {
    return {
      previewImage: '',
      loading:false,
      previewVisible:false,
      fileList:this.fileListInit,
      imageUrl:this.imageInit
    };
  },
  watch: {
    imageInit(val){
        this.imageUrl=val
    },
    fileListInit(val)
    {
      this.fileList=val
    }
  },
  mounted(){
    console.log("重新加载上传组件")
  },
  methods:{
    beforeUpload(file)
    {
       if(this.fileVaildtor)
       {

        if(this.fileVaildtor.fileType&&fileVaildtor.fileType.indexOf(file.file.type)==-1)
        {
          this.$message.error('文件格式不正确！')
        }
        if(this.fileVaildtor.fileSize&&file.file.size>this.fileVaildtor.fileSize)
        {
          this.$message.error('文件超过大小限制，'+parseInt(this.fileVaildtor.fileSize/1024/1024)+'M')
        }
       }
    },
    async uploadImg(file){
        if(this.showUploadList&&this.fileList.length+1>this.imageCount)
        {
          this.$message.success("最多上传"+this.imageCount+"个文件");
          return
        }
       
        this.loading = true
        let formData = new FormData()
        formData.append('file',file.file)
        let data= await api.UploadGoodImg(formData)
        if(data)
        {
          this.loading = false
          this.uploadChange(file.file.uid,data)
        }
        else
        {
          this.$message.success("文件："+file.file.name+"上传失败，请重新上传！");
          this.cancelFile(file.file)
          
        }
      
    },
    imageChange(file)
    {
      if(file.file.status=="uploading")
      {
         if(this.showUploadList&&file.fileList.length>this.imageCount)
          {
            this.$message.success("最多上传"+this.imageCount+"个文件");
            return
          }
        this.fileList= this.fileList.concat([{
            uid: file.file.uid,
            name: file.file.name,
            status: file.file.status,
            url: file.file.thumbUrl,
          }])
          console.log(this.fileList)
      }
      if(file.file.status==="removed")
      {
        this.cancelFile(file.file)
      }
    },
    
    uploadChange(uid,file)
    {
      if(this.imageCount===0)
      {
        this.imageUrl=file[0].path
        this.fileList=[{uid: Math.random().toString(),
          name: file[0].name,
          status: 'done',
          url: file[0].path}]
        this.$emit("uploadChange",this.fileList)
      }
      else 
      {
        let index=this.fileList.length-1
        if(this.multiple)
        {
           index=this.fileList.findIndex(item=>item.uid===uid)
        }
        this.fileList.splice(index,1,{
          uid: Math.random().toString(),
          name: file[0].name,
          status: 'done',
          url: file[0].path,
        }) 
        this.$emit("uploadChange",this.fileList)
      }
    },
    cancelFile(file)
    {
      let index=this.fileList.findIndex(item=>item.uid===file.uid)
      this.fileList.splice(index,1)
      this.$emit("cancelFile",this.fileList)
    },

    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleCancel () {
      this.previewVisible = false
    },
  }
}
</script>

<style lang="scss"  >
.upImg{width: 100%;height: 100%;}
.fleft .ant-upload{float: left;}
.fleft .ant-upload-list{float: left;}
.fleft .ant-upload-list-item-info{padding: 0px;}
.fleft {}

.signalCla{width: 100%;height: 100%;}
.signalCla .ant-upload.ant-upload-select-picture-card  .ant-upload { height: 104px; padding: 0;   display: block; overflow: hidden;}
.signalCla .ant-upload.ant-upload-select-picture-card { display: block; border: 1px solid #d9d9d9; height: 100%; }
.upload-Add{padding-top: 30px}
</style>



// WEBPACK FOOTER //
// src/components/upload/UploadImage.vue